module.exports = __webpack_public_path__ + "static/media/open-envelope.e86d55e1.svg";